// 'Metric' dropdown options:
export const MetricDropdown = [
  {
    id: 1,
    name: "mentions",
  },
  {
    id: 2,
    name: "sentiment",
  },
  {
    id: 4,
    name: "reach",
  },
  {
    id: 5,
    name: "amplification",
  },
  {
    id: 6,
    name: "ave",
  },
];

export const savedSearchMetricDropdown = [
  {
    id: 1,
    name: "mentions",
  },
  {
    id: 2,
    name: "sentiment",
  },
  {
    id: 4,
    name: "reach",
  },
  {
    id: 5,
    name: "amplification",
  },
  {
    id: 6,
    name: "ave",
  },
];

export const comparisonSetMetricDropdown = [
  {
    id: 1,
    name: "mentions",
  },
  {
    id: 2,
    name: "sentiment",
  },
  {
    id: 4,
    name: "reach",
  },
  {
    id: 5,
    name: "amplification",
  },
  {
    id: 6,
    name: "ave",
  },
];

// 'Slice By' dropdown options:
const timeOpt = {
  id: 1,
  name: "time",
};

const mediaTypeOpt = {
  id: 2,
  name: "media_type",
};

const snapshotOpt = {
  id: 6,
  name: "snapshot",
};

const competitorOpt = {
  id: 7,
  name: "competitors",
};

export const savedSearchSliceByDropdowns = {
  mentions: [timeOpt, mediaTypeOpt],
  sentiment: [timeOpt, snapshotOpt],
  amplification: [timeOpt, mediaTypeOpt],
  ave: [timeOpt, mediaTypeOpt],
  reach: [timeOpt, mediaTypeOpt],
};

export const comparisonSetSliceByDropdowns = {
  mentions: [timeOpt, mediaTypeOpt, competitorOpt],
  sentiment: [timeOpt, snapshotOpt],
  amplification: [competitorOpt, timeOpt, mediaTypeOpt],
  ave: [competitorOpt, mediaTypeOpt, timeOpt],
  reach: [competitorOpt, timeOpt, mediaTypeOpt],
};

export const chartTypeMap = {
  mentions: {
    time: ["line", "column", "bar"],
    media_type: ["pie", "column", "bar"],
    competitors: ["pie"],
  },
  sentiment: {
    time: ["line", "column", "bar"],
    snapshot: ["pie"],
  },
  reach: {
    competitors: ["pie"],
    time: ["line", "column", "bar"],
    media_type: ["pie", "column", "bar"],
  },
  amplification: {
    competitors: ["pie"],
    time: ["line", "column", "bar"],
    media_type: ["pie", "column", "bar"],
  },
  ave: {
    competitors: ["pie"],
    time: ["column", "line", "bar"],
    media_type: ["pie", "column", "bar"],
  },
};

/*
  Avast! Ye have entered uncharted waters!
  The below code be the original code that was plundered and pillaged.
  If these options mean nothing to you by the time you read this, they can be deleted.
  TODO: re-enable use of all charts once their series logic has been defined
*/

// 'Metric' dropdown options:
// export const MetricDropdown = [
//   {
//     id: 1,
//     name: "mentions",
//   },
//   {
//     id: 2,
//     name: "sentiment",
//   },
//   {
//     id: 3,
//     name: "media_type",
//   },
//   {
//     id: 4,
//     name: "reach",
//   },
//   {
//     id: 5,
//     name: "amplification",
//   },
//   {
//     id: 6,
//     name: "ave",
//   },
//   {
//     id: 7,
//     name: "topics",
//   },
// ];

// 'Slice By' dropdown options:
// const countryOpt = {
//   id: 3,
//   name: "country",
// };

// const languageOpt =
//   id: 4,
//   name: "language",
// };

// const sentimentOpt = {
//   id: 5,
//   name: "sentiment",
// };

// export const SliceByDropdowns = {
//   mentions: [timeOpt, mediaTypeOpt, countryOpt, languageOpt, sentimentOpt],
//   sentiment: [snapshotOpt],
//   mediaType: [countryOpt, languageOpt],
//   reach: [timeOpt, mediaTypeOpt, countryOpt, languageOpt],
//   amplification: [timeOpt, mediaTypeOpt, countryOpt, languageOpt],
//   ave: [timeOpt, mediaTypeOpt, countryOpt, languageOpt],
//   topics: [snapshotOpt, timeOpt],
// };

// export const chartTypeMap = {
//   mentions: {
//     time: ["line", "column", "bar"],
//     media_type: ["pie", "column", "bar"],
//     country: ["pie", "column", "bar", "map"],
//     language: ["pie", "column", "bar"],
//     sentiment: ["line", "column", "bar"],
//   },
//   sentiment: {
//     snapshot: ["pie"],
//   },
//   mediaType: {
//     country: ["stackedcolumn"],
//     language: ["stackedcolumn"],
//   },
//   reach: {
//     time: ["line", "column", "bar"],
//     media_type: ["pie", "column", "bar"],
//     country: ["pie", "column", "bar"],
//     language: ["pie", "column", "bar"],
//   },
//   amplification: {
//     time: ["line", "column", "bar"],
//     media_type: ["pie", "column", "bar"],
//     country: ["pie", "column", "bar"],
//     language: ["pie", "column", "bar"],
//   },
//   ave: {
//     time: ["line", "column", "bar"],
//     media_type: ["pie", "column", "bar"],
//     country: ["pie", "column", "bar"],
//     language: ["pie", "column", "bar"],
//   },
//   topics: {
//     snapshot: ["packedbubble"],
//     time: ["line", "column", "bar"],
//   },
// };
